import React from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import ErrorBoundary from "./components/ErrorBoundary";
import { AuthProvider } from "./contexts/AuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { useLanguage } from "./contexts/LanguageContext";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import BenefitsSection from "./components/BenefitsSection";
import PresentationSection from "./components/PresentationSection";
import ProductCatalog from "./components/ProductCatalog";
import ProductionSection from "./components/ProductionSection";
import DealerNetwork from "./components/DealerNetwork";
import CaseStudies from "./components/CaseStudies";
import NewsSection from "./components/NewsSection";
import CertificatesSection from "./components/CertificatesSection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import TeamSection from "./components/TeamSection";
import DealerPage from "./components/DealerPage";
import DealerApplyPage from "./components/DealerApplyPage";
import BrandReviewPage from "./components/BrandReviewPage";

function HomePage() {
  return (
    <>
      <Header />
      <HeroSection />
      <BenefitsSection />
      <PresentationSection />
      <ProductCatalog />
      <ProductionSection />
      <TeamSection />
      <DealerNetwork />
      <CaseStudies />
      <NewsSection />
      <CertificatesSection />
      <FAQSection />
      <ContactSection />
      <Footer />
    </>
  );
}

function AppInner() {
  const { isRtl } = useLanguage();
  return (
    <div className="App" dir={isRtl ? 'rtl' : 'ltr'}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/dealer" element={<DealerPage />} />
        <Route path="/dealer/apply" element={<DealerApplyPage />} />
        <Route path="/brand" element={<BrandReviewPage />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <LanguageProvider>
          <AppInner />
        </LanguageProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
